module.exports = __webpack_public_path__ + "static/media/car-art.f3158d32.png";